var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogin = function SvgLogin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.99 20.5V19h6.702a.3.3 0 0 0 .212-.096.3.3 0 0 0 .096-.212V5.308a.3.3 0 0 0-.096-.212.3.3 0 0 0-.212-.096h-6.701V3.5h6.701q.758 0 1.283.525t.525 1.283v13.384q0 .758-.525 1.283t-1.283.525zm-1.355-4.23-1.039-1.085 2.435-2.435H3.5v-1.5h8.53L9.597 8.816l1.039-1.085L14.904 12z"
  })));
};
export default SvgLogin;